import { Component } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Evento, Spettacolo } from '../../../../shared/interface';

@Component({
  selector: 'app-accredito-spettacolo-backoffice',
  templateUrl: './accredito-spettacolo-backoffice.component.html',
  styleUrl: './accredito-spettacolo-backoffice.component.css'
})
export class AccreditoSpettacoloBackofficeComponent {

  constructor(
    private apiService: ApiService,    
    private router: Router,
    private route: ActivatedRoute,        
  ) {}
    
  spettacolo?: Spettacolo;
  evento?: Evento;

  loading: boolean = false;
    
  ngOnInit(): void {    
      
    this.route.params.subscribe((params) => {
      this.loading = true;
      const id = params['id'];
      this.apiService.getSpettacolo(id).subscribe({
        next: (data) => this.spettacolo = data,
        error: (err) => this.router.navigate(['/backoffice/spettacoli']),
        complete: () => {    
          this.apiService.getEventoSpettacolo(id).subscribe({
            next: (data) => this.evento = data,
            error: (err) => this.router.navigate(['/backoffice/spettacoli']),
            complete: () => this.loading = false
          })
        }
      })          
    })
  }

}
